import { graphQlClient } from '@config/graphqlClient';
import StandaloneInvoiceGraphQL from '@graphql/standaloneInvoice.queries';

export interface StandaloneLineItemInput {
  description: string;
  quantity: number;
  unitPrice: number;
}

export interface CreateStandaloneInvoiceInput {
  recipientEmail: string;
  currency?: string;
  lineItems: StandaloneLineItemInput[];
  organizationId?: string;
  projectId?: string;
  taxRate?: number;
  discountRate?: number;
  discountFixedAmount?: number;
}

export interface StandaloneInvoiceLineItem {
  description: string;
  quantity: number;
  unitPrice: number;
  lineTotal: number;
}

export interface StandaloneInvoice {
  standaloneInvoiceId: string;
  recipientEmail: string;
  currency: string;
  subtotal: number;
  taxRate: number;
  tax: number;
  discountRate: number;
  discountFixedAmount: number;
  discountAmount: number;
  total: number;
  organizationId: string | null;
  projectId: string | null;
  status: 'SENDING' | 'SENT' | 'SEND_FAILED';
  nmiInvoiceId: string | null;
  sentAt?: string | null;
  createdAt: string;
  lineItems: StandaloneInvoiceLineItem[];
}

export interface StandaloneInvoiceProjectOption {
  projectId: string;
  name: string;
}

export const standaloneInvoiceService = {
  async createAndSend(input: CreateStandaloneInvoiceInput): Promise<StandaloneInvoice> {
    const data: any = await graphQlClient.request(StandaloneInvoiceGraphQL.mutations.createAndSend, {
      input,
    });
    return data.createAndSendStandaloneInvoice;
  },

  async getProjectsForOrganization(organizationId: string): Promise<StandaloneInvoiceProjectOption[]> {
    const data: any = await graphQlClient.request(
      StandaloneInvoiceGraphQL.queries.projectsForStandaloneInvoice,
      { organizationId },
    );
    return data.projectsForStandaloneInvoice ?? [];
  },
};
